import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useApi, errMsg } from "@/lib/api";

const inputCls = "mt-1 w-full rounded-md border border-white/10 bg-[#0A0A0A] px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#FF5A00]";

export function HostLinkDialog({ car, onOpenChange, onSaved }) {
  const api = useApi();
  const [email, setEmail] = useState("");
  const [share, setShare] = useState(70);
  useEffect(() => {
    if (car) {
      setEmail(car.host_email || "");
      setShare(car.host_share_pct || 70);
    }
  }, [car]);
  const save = async (clear) => {
    try {
      await api.patch(`/admin/cars/${car.id}/host`, { email: clear ? "" : email, share_pct: Number(share) });
      toast.success(clear ? "Host removed" : "Host linked");
      onSaved();
      onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={!!car} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="host-link-dialog">
        <DialogHeader><DialogTitle>Car owner for {car?.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-neutral-400">The owner signs in with this email to see this car's bookings and earnings. Their share is a % of the rental charge (excluding GST and fees).</p>
        <label className="text-xs text-neutral-400">Owner email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="owner@example.com" data-testid="host-link-email" className={inputCls} />
        </label>
        <label className="text-xs text-neutral-400">Owner share (%)
          <input type="number" min="0" max="100" value={share} onChange={(e) => setShare(e.target.value)} data-testid="host-link-share" className={inputCls} />
        </label>
        <div className="flex justify-between gap-2">
          {car?.host_email && <button onClick={() => save(true)} data-testid="host-link-remove" className="rounded-md px-4 py-2 text-sm text-rose-400 hover:bg-white/10">Remove owner</button>}
          <button onClick={() => save(false)} disabled={!email} data-testid="host-link-save" className="ml-auto rounded-md bg-[#FF5A00] px-5 py-2 text-sm font-semibold text-white disabled:opacity-50">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
